import { CustClearReqAction } from 'common/constant';
import { AppRoutes } from 'helpers/app.routes';
import React, { lazy } from 'react';
import icon_menu_business from 'resources/images/icon_menu_business.svg';
import icon_menu_dashboard from 'resources/images/icon_menu_dashboard.svg';
import icon_menu_display from 'resources/images/icon_menu_display.svg';
import icon_menu_edi from 'resources/images/icon_menu_edi.svg';
import icon_menu_hbl from 'resources/images/icon_menu_hbl.svg';
import icon_menu_notify from 'resources/images/icon_menu_notify.svg';
import icon_menu_report from 'resources/images/icon_menu_report.svg';
import icon_menu_ship from 'resources/images/icon_menu_ship.svg';
// import icon_menu_chat from 'resources/images/icon_menu_chat.svg';

const LoginPage = lazy(() => import('pages/auth/LoginPage'));
const ChangePassword = lazy(() => import('pages/auth/ChangePassword'));
const BLInformationSearch = lazy(() => import('pages/bl-info/search'));
const BLEntryDetailForm = lazy(() => import('pages/bl-info/update'));
const ContainerInformation = lazy(() => import('pages/container-info'));
const CargoTraceSearchPage = lazy(() => import('pages/cargo-trace-search'));
const ShipInfoStatus = lazy(() => import('pages/ship-info/ship-status'));
const ShipMovementInfoUpload = lazy(() => import('pages/ship-info/ship-movement-info-upload'));
const TraceInfoPreAlert = lazy(() => import('pages/trace-info/pre-alert'));
const OutputReportInfomation = lazy(() => import('pages/output-report-info'));
const ShipMovementSearchPage = lazy(() => import('pages/ship-movement-search'));
const EdiLogList = lazy(() => import('pages/edi-log-list'));
const EdiLogDetail = lazy(() => import('pages/edi-log-list/Detail'));
const DisplayItemMaintenance = lazy(() => import('pages/display-item-master'));
const RegisterPage = lazy(() => import('pages/display-item-master/containers/Register'));
const UserMaintance = lazy(() => import('pages/user-maintance'));
const AccountMaster = lazy(() => import('pages/account-master/search'));
const AccountRegister = lazy(() => import('pages/account-master/register'));
const UpdateUserMaintance = lazy(() => import('pages/user-maintance/update'));
const DeleteUserMaintance = lazy(() => import('pages/user-maintance/delete'));
const AddUserMaintance = lazy(() => import('pages/user-maintance/add'));
const HblStatus = lazy(() => import('pages/hbl-status/search'));
const HblStatusUpdate = lazy(() => import('pages/hbl-status/update'));
const HblDocumentUpload = lazy(() => import('pages/hbl-status/document-upload'));
const HblInfoUpload = lazy(() => import('pages/hbl-status/hbl-info-upload'));
const ContainerStatus = lazy(() => import('pages/container-status'));
const AccountGrMaster = lazy(() => import('pages/account-group-master/search'));
const AccountGrRegister = lazy(() => import('pages/account-group-master/register'));
const PortMaster = lazy(() => import('pages/port-master/search'));
const PortRegister = lazy(() => import('pages/port-master/register'));
const GeneralMaster = lazy(() => import('pages/general-master/search'));
const GeneralRegister = lazy(() => import('pages/general-master/register'));
const SearchPattern = lazy(() => import('pages/search-pattern/search'));
const SearchPatternRegister = lazy(() => import('pages/search-pattern/register'));
const DocumentApproval = lazy(() => import('pages/document-approval/search'));
const StatusMaster = lazy(() => import('pages/status-master/search'));
const StatusRegister = lazy(() => import('pages/status-master/register'));
const AitGrMaster = lazy(() => import('pages/ait-group-master/search'));
const AitGrRegister = lazy(() => import('pages/ait-group-master/register'));
const MenuAuthorityMaster = lazy(() => import('pages/menu-authority-master/search'));
const MenuAuthorityRegister = lazy(() => import('pages/menu-authority-master/register'));
const CustomsClearanceRequestSearch = lazy(() => import('pages/customs-clearance-request-search'));
const CustomsClearanceRequestInfo = lazy(() => import('pages/customs-clearance-request-info'));
const CustomsClearanceRequestRegister = lazy(() => import('pages/customs-clearance-request-register'));
const DeliveryDestMaster = lazy(() => import('pages/delivery-dest-master/search'));
const DeliveryDestRegister = lazy(() => import('pages/delivery-dest-master/register'));
const NotificationSearch = lazy(() => import('pages/notification/search'));
const NotificationSetting = lazy(() => import('pages/notification/setting'));
const CargoTraceSearchPageExport = lazy(() => import('pages/cargo-trace-search-export'));
const TraceInfoPreAlertExport = lazy(() => import('pages/trace-info-export/pre-alert'));
const CustomsClearanceRequestSearchExport = lazy(() => import('pages/customs-clearance-request-search-export'));
const CustomsClearanceRequestInfoExport = lazy(() => import('pages/customs-clearance-request-info-export'));
const CustomsClearanceRequestRegisterExport = lazy(() => import('pages/customs-clearance-request-register-export'));
const BLInformationSearchExport = lazy(() => import('pages/bl-info-export/search'));
const BLEntryDetailFormExport = lazy(() => import('pages/bl-info-export/update'));
const HblDocumentUploadExport = lazy(() => import('pages/hbl-status-export/document-upload'));

export const SCREEN_ID = {
  SCREEN_MENU: '030101',
  SCREEN_CARGO_TRACE_INFO: '040101',
  SCREEN_SHIP_MOTION: '040201',
  SCREEN_SHIP_UPLOAD: '040202',
  SCREEN_SHIP_UPDATE: '060201',
  SCREEN_HBL_STATUS_SEARCH: '060301',
  SCREEN_HBL_STATUS_UPDATE: '060304',
  SCREEN_HBL_STATUS_DOC_UPLOAD: '060305',
  SCREEN_HBL_STATUS_INFO_UPLOAD: '060306',
  SCREEN_BL_INFOR: '060601',
  SCREEN_BL_INFOR_REGISTER: '060602',
  SCREEN_BL_INFOR_UPDATE: '060603',
  SCREEN_BL_INFOR_DELETE: '060604',
  SCREEN_BL_INFOR_COPY: '060605',
  SCREEN_EDI: '160101',
  SCREEN_EDI_DETAIL: '160102',
  SCREEN_DISPLAY_ITEM: '090901',
  SCREEN_DISPLAY_ITEM_SELECTION: '090902',
  SCREEN_DISPLAY_ITEM_COPY: '090903',
  SCREEN_DISPLAY_ITEM_REGISTRATION: '090904',
  SCREEN_DISPLAY_ITEM_UPDATE: '090905',
  SCREEN_DISPLAY_ITEM_DELETE: '090906',
  SCREEN_OUTPUT_REPORT: '160301',
  SCREEN_ACCOUNT_MASTER_SEARCH: '091901',
  SCREEN_ACCOUNT_MASTER_ADD: '091902',
  SCREEN_ACCOUNT_MASTER_UPDATE: '091903',
  SCREEN_ACCOUNT_MASTER_DELETE: '091904',
  SCREEN_USER_MAINTANCE: '090101',
  SCREEN_USER_MAINTANCE_ADD: '090102',
  SCREEN_USER_MAINTANCE_UPDATE: '090103',
  SCREEN_USER_MAINTANCE_DELETE: '090104',
  SCREEN_GENERAL_MASTER_SEARCH: '092001',
  SCREEN_GENERAL_MASTER_ADD: '092002',
  SCREEN_GENERAL_MASTER_UPDATE: '092003',
  SCREEN_ACCOUNT_GR_MASTER_SEARCH: '090201',
  SCREEN_ACCOUNT_GR_MASTER_ADD: '090202',
  SCREEN_ACCOUNT_GR_MASTER_UPDATE: '090203',
  SCREEN_ACCOUNT_GR_MASTER_DELETE: '090204',
  SCREEN_PORT_MASTER_SEARCH: '091601',
  SCREEN_PORT_MASTER_ADD: '091601',
  SCREEN_PORT_MASTER_UPDATE: '091601',
  SCREEN_PORT_MASTER_DELETE: '091601',
  SCREEN_SEARCH_PATTERN_SEARCH: '160401',
  SCREEN_SEARCH_PATTERN_ADD: '160402',
  SCREEN_SEARCH_PATTERN_UPDATE: '160403',
  SCREEN_SEARCH_PATTERN_DELETE: '160404',
  SCREEN_SEARCH_DOCUMENT_APPROVAL: '060401',
  SCREEN_CONTAINER_STATUS: '060501',
  SCREEN_STATUS_MASTER_SEARCH: '090301',
  SCREEN_STATUS_MASTER_ADD: '090302',
  SCREEN_STATUS_MASTER_UPDATE: '090303',
  SCREEN_STATUS_MASTER_DELETE: '090304',
  SCREEN_MENU_AUTHORITY_MASTER_SEARCH: '090601',
  SCREEN_MENU_AUTHORITY_MASTER_ADD: '090602',
  SCREEN_MENU_AUTHORITY_MASTER_UPDATE: '090603',
  SCREEN_MENU_AUTHORITY_MASTER_DELETE: '090604',
  SCREEN_AIT_GR_MASTER_SEARCH: '092101',
  SCREEN_AIT_GR_MASTER_ADD: '092102',
  SCREEN_AIT_GR_MASTER_UPDATE: '092103',
  SCREEN_AIT_GR_MASTER_DELETE: '092104',
  SCREEN_CHAT_ROOM: '080101',
  CUSTOMS_CLEARANCE_REQUEST_SEARCH: '170101',
  CUSTOMS_CLEARANCE_REQUEST_DETAIL: '170301',
  CUSTOMS_CLEARANCE_REQUEST_INFO: '170401',
  CUSTOMS_CLEARANCE_REQUEST_ADD: '170402',
  CUSTOMS_CLEARANCE_REQUEST_UPDATE: '170403',
  CUSTOMS_CLEARANCE_REQUEST_DELETE: '170404',
  SCREEN_DELIVERY_DEST_MASTER_SEARCH: '092201',
  SCREEN_DELIVERY_DEST_MASTER_ADD: '092202',
  SCREEN_DELIVERY_DEST_MASTER_UPDATE: '092203',
  SCREEN_DELIVERY_DEST_MASTER_DELETE: '092204',
  SCREEN_NOTIFICATION_SEARCH: '180101',
  SCREEN_NOTIFICATION_SETTING: '180201',
  SCREEN_CARGO_TRACE_INFO_EXPORT: '340101',
  SCREEN_HBL_STATUS_DOC_EXPORT_UPLOAD: '360305',
  SCREEN_BL_INFOR_EXPORT: '360601',
  SCREEN_BL_INFOR_EXPORT_REGISTER: '360602',
  SCREEN_BL_INFOR_EXPORT_UPDATE: '360603',
  SCREEN_BL_INFOR_EXPORT_DELETE: '360604',
  SCREEN_BL_INFOR_EXPORT_COPY: '360605',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_SEARCH: '370101',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_DETAIL: '370301',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_INFO: '370401',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_ADD: '370402',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_UPDATE: '370403',
  CUSTOMS_CLEARANCE_REQUEST_EXPORT_DELETE: '370404',
};

export const publicRoutes = [
  {
    name: 'login',
    path: AppRoutes.login,
    component: LoginPage,
    exact: true,
  },
  {
    name: 'change-password',
    path: AppRoutes.changePassword,
    component: ChangePassword,
    exact: true,
  },
  // (preアラート)
  {
    name: 'change-password',
    path: AppRoutes.preAlertFileShare,
    component: TraceInfoPreAlert,
    exact: true,
  },
];

export const privateRoutes = (t) => {
  return [
    {
      path: AppRoutes.main,
      component: CargoTraceSearchPage,
      inMenu: false,
      icon: <img src={icon_menu_dashboard} alt="icon_menu_dashboard" />,
      exact: true,
      screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO,
    },
    // 貨物トレース検索
    {
      name: t('menu.cargo_trace'),
      path: AppRoutes.cargoInformationSearch,
      icon: <img src={icon_menu_hbl} alt="icon_menu_hbl" />,
      inMenu: true,
      exact: true,
      subTitle: t('menu.in_cargo_trace_submenu_title'),
      subMenu: [
        // 貨物トレース検索
        {
          name: t('menu.cargo_trace_search'),
          path: AppRoutes.cargoInformationSearch,
          component: CargoTraceSearchPage,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO,
        },
        // (preアラート)
        {
          path: AppRoutes.preAlertSearch,
          component: TraceInfoPreAlert,
          exact: true,
          inMenu: false,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO,
        },
        // (preアラート(チャット))
        {
          path: AppRoutes.preAlertChatSearch,
          component: TraceInfoPreAlert,
          exact: true,
          inMenu: false,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO,
        },
        // (コンテナ情報)
        {
          path: AppRoutes.containerInfoSearch,
          component: ContainerInformation,
          exact: true,
          inMenu: false,
          displayByDefault: true,
        },
        // 本船動静情報検索
        {
          name: t('menu.ship_movement_search'),
          path: AppRoutes.shipMovementSearch,
          component: ShipMovementSearchPage,
          exact: true,
          inMenu: true,
          screenId: SCREEN_ID.SCREEN_SHIP_MOTION,
        },
        // (本船情報アップロード)
        {
          path: AppRoutes.reportBundleShipUpload,
          component: ShipMovementInfoUpload,
          exact: true,
          inMenu: false,
          screenId: SCREEN_ID.SCREEN_SHIP_UPLOAD,
        },
        // 貨物トレース検索(輸出)
        {
          name: t('menu.cargo_trace_search_export'),
          path: AppRoutes.cargoInformationExportSearch,
          component: CargoTraceSearchPageExport,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO_EXPORT,
        },
        // (preアラート(輸出))
        {
          path: AppRoutes.preAlertExportSearch,
          component: TraceInfoPreAlertExport,
          exact: true,
          inMenu: false,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO_EXPORT,
        },
        // ドキュメントアップロード（輸出）
        {
          path: AppRoutes.hblStatusDocExportUpload,
          component: HblDocumentUploadExport,
          exact: true,
          inMenu: false,
          screenId: SCREEN_ID.SCREEN_CARGO_TRACE_INFO_EXPORT,
        },
      ],
    },
    // 通関依頼メニュー
    {
      name: t('menu.customs_clearance_request'),
      path: AppRoutes.customsClearance,
      icon: <img src={icon_menu_ship} alt="icon_menu_ship" />,
      inMenu: true,
      exact: true,
      subTitle: t('menu.in_customs_clearance_submenu_title'),
      subMenu: [
        // 通関依頼登録／更新／削除
        {
          name: t('menu.new_customs_clearance_request'),
          path: AppRoutes.customsClearanceRequestRegisterSearchId(
            CustClearReqAction.CUST_CLEAR_REQ_NO_DEFAULT,
            CustClearReqAction.REGISTER,
            CustClearReqAction.PRE_SCREEN_MENU,
            CustClearReqAction.HBL_NO_DEFAULT
          ),
          component: CustomsClearanceRequestRegister,
          inMenu: true,
          exact: true,
          screenId: [SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_ADD],
        },
        // 通関依頼登録／更新／削除 (詳細)
        {
          path: AppRoutes.customsClearanceRequestRegisterSearch,
          component: CustomsClearanceRequestRegister,
          inMenu: false,
          exact: true,
          screenId: [
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_DETAIL,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_ADD,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_UPDATE,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_DELETE,
          ],
        },
        // 通関依頼検索
        {
          name: t('menu.customs_clearance_request_search'),
          path: AppRoutes.customsClearanceRequestSearch,
          component: CustomsClearanceRequestSearch,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_SEARCH,
        },
        // 通関依頼履歴
        {
          path: AppRoutes.customsClearanceRequestInfoSearch,
          component: CustomsClearanceRequestInfo,
          inMenu: false,
          exact: true,
          screenId: SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_INFO,
        },
        // 納品先マスタ登録／更新／削除
        {
          path: AppRoutes.deliveryDestMasterSearch,
          component: DeliveryDestRegister,
          exact: true,
          inMenu: false,
          screenId: [
            SCREEN_ID.SCREEN_DELIVERY_DEST_MASTER_ADD,
            SCREEN_ID.SCREEN_DELIVERY_DEST_MASTER_UPDATE,
            SCREEN_ID.SCREEN_DELIVERY_DEST_MASTER_DELETE,
          ],
        },
        // 通関依頼登録／更新／削除（輸出）
        {
          name: t('menu.new_customs_clearance_request_export'),
          path: AppRoutes.customsClearanceRequestExportRegisterSearchId(
            CustClearReqAction.CUST_CLEAR_REQ_NO_DEFAULT,
            CustClearReqAction.REGISTER,
            CustClearReqAction.PRE_SCREEN_MENU,
            CustClearReqAction.HBL_NO_DEFAULT
          ),
          component: CustomsClearanceRequestRegisterExport,
          inMenu: true,
          exact: true,
          screenId: [SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_ADD],
        },
        // 通関依頼登録／更新／削除 (詳細)（輸出）
        {
          path: AppRoutes.customsClearanceRequestExportRegisterSearch,
          component: CustomsClearanceRequestRegisterExport,
          inMenu: false,
          exact: true,
          screenId: [
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_DETAIL,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_ADD,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_UPDATE,
            SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_DELETE,
          ],
        },
        // 通関依頼検索（輸出）
        {
          name: t('menu.customs_clearance_request_search_export'),
          path: AppRoutes.customsClearanceRequestExportSearch,
          component: CustomsClearanceRequestSearchExport,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_SEARCH,
        },
        // 通関依頼履歴（輸出）
        {
          path: AppRoutes.customsClearanceRequestExportInfoSearch,
          component: CustomsClearanceRequestInfoExport,
          inMenu: false,
          exact: true,
          screenId: SCREEN_ID.CUSTOMS_CLEARANCE_REQUEST_EXPORT_INFO,
        },
        // 納品先マスタメンテナンス
        {
          name: t('menu.delivery_dest_master'),
          path: AppRoutes.deliveryDestMaster,
          component: DeliveryDestMaster,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.SCREEN_DELIVERY_DEST_MASTER_SEARCH,
        },
      ],
    },
    // 通知情報メニュー
    {
      name: t('menu.notification_information'),
      path: AppRoutes.notification,
      icon: <img src={icon_menu_notify} alt="icon_menu_notify" />,
      exact: true,
      inMenu: true,
      subTitle: t('menu.in_notification_information_title'),
      subMenu: [
        // 通知情報
        {
          name: t('menu.notification_information'),
          path: AppRoutes.notificationInformation,
          component: NotificationSearch,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.SCREEN_NOTIFICATION_SEARCH,
        },
        // 通知設定
        {
          name: t('menu.notification_setting'),
          path: AppRoutes.notificationSetting,
          component: NotificationSetting,
          inMenu: true,
          exact: true,
          screenId: SCREEN_ID.SCREEN_NOTIFICATION_SETTING,
        },
      ],
    },
    // サブメニュー
    {
      name: t('menu.in_submenu_title'),
      path: AppRoutes.submenu,
      icon: <img src={icon_menu_business} alt="icon_menu_business" />,
      inMenu: true,
      exact: true,
      subTitle: t('menu.in_submenu_title'),
      subMenu: [
        // レポート出力
        {
          name: t('menu.report_output'),
          path: AppRoutes.outputReport,
          component: OutputReportInfomation,
          inMenu: true,
          icon: <img src={icon_menu_report} alt="icon_menu_report" />,
          exact: true,
          screenId: SCREEN_ID.SCREEN_OUTPUT_REPORT,
        },
        // 社内運用業務
        {
          name: t('menu.in_house_operation'),
          path: AppRoutes.reportBundle,
          icon: <img src={icon_menu_business} alt="icon_menu_business" />,
          inMenu: true,
          exact: true,
          subTitle: t('menu.in_house_operation_submenu_title'),
          subMenu: [
            // BL情報一覧検索
            {
              name: t('menu.bl_info'),
              path: AppRoutes.reportBundleTraceSearch,
              component: BLInformationSearch,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_BL_INFOR,
            },
            {
              path: AppRoutes.reportBundleTraceActionSearch,
              component: BLEntryDetailForm,
              exact: true,
              inMenu: false,
              screenId: [SCREEN_ID.SCREEN_BL_INFOR_REGISTER],
            },
            {
              path: AppRoutes.reportBundleSubMenuActionSearch,
              component: BLEntryDetailForm,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_BL_INFOR_UPDATE,
                SCREEN_ID.SCREEN_BL_INFOR_COPY,
                SCREEN_ID.SCREEN_BL_INFOR_DELETE,
              ],
            },
            // 本船ステータス更新
            {
              name: t('menu.ship_status'),
              path: AppRoutes.reportBundleShipStatus,
              component: ShipInfoStatus,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_SHIP_UPDATE,
            },
            // HBLステータス更新
            {
              name: t('menu.hbl_status'),
              path: AppRoutes.hblStatus,
              component: HblStatus,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_HBL_STATUS_SEARCH,
            },
            {
              path: AppRoutes.hblStatusUpdate,
              component: HblStatusUpdate,
              exact: true,
              inMenu: false,
              screenId: SCREEN_ID.SCREEN_HBL_STATUS_UPDATE,
            },
            {
              path: AppRoutes.hblStatusDocUpload,
              component: HblDocumentUpload,
              exact: true,
              inMenu: false,
              screenId: SCREEN_ID.SCREEN_HBL_STATUS_DOC_UPLOAD,
            },
            {
              path: AppRoutes.hblStatusInfoUpload,
              component: HblInfoUpload,
              exact: true,
              inMenu: false,
              screenId: SCREEN_ID.SCREEN_HBL_STATUS_INFO_UPLOAD,
            },
            // コンテナ情報ステータス更新
            {
              name: t('menu.container_status'),
              path: AppRoutes.containerStatus,
              component: ContainerStatus,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_CONTAINER_STATUS,
            },
            // 帳票承認
            {
              name: t('menu.document_approval'),
              path: AppRoutes.documentApploval,
              component: DocumentApproval,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_SEARCH_DOCUMENT_APPROVAL,
            },
            // EDIログ一覧
            {
              name: t('menu.edi_log_list'),
              path: AppRoutes.ediLogList,
              component: EdiLogList,
              inMenu: true,
              icon: <img src={icon_menu_edi} alt="icon_menu_edi" />,
              exact: true,
              screenId: SCREEN_ID.SCREEN_EDI,
            },
            {
              path: AppRoutes.ediLogListSearch,
              component: EdiLogDetail,
              inMenu: false,
              exact: true,
              screenId: SCREEN_ID.SCREEN_EDI_DETAIL,
            },
            // BL情報一覧検索(輸出)
            {
              name: t('menu.bl_info_export'),
              path: AppRoutes.reportBundleTraceExportSearch,
              component: BLInformationSearchExport,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_BL_INFOR_EXPORT,
            },
            {
              path: AppRoutes.reportBundleTraceExportActionSearch,
              component: BLEntryDetailFormExport,
              exact: true,
              inMenu: false,
              screenId: [SCREEN_ID.SCREEN_BL_INFOR_EXPORT_REGISTER],
            },
            {
              path: AppRoutes.reportBundleSubMenuExportActionSearch,
              component: BLEntryDetailFormExport,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_BL_INFOR_EXPORT_UPDATE,
                SCREEN_ID.SCREEN_BL_INFOR_EXPORT_COPY,
                SCREEN_ID.SCREEN_BL_INFOR_EXPORT_DELETE,
              ],
            },
          ],
        },
        // マスタメンテナンス
        {
          name: t('menu.master_maintenance'),
          path: AppRoutes.masterMaintance,
          icon: <img src={icon_menu_display} alt="icon_menu_display" />,
          inMenu: true,
          exact: true,
          subTitle: t('menu.master_maintenance_submenu_title'),
          subMenu: [
            // ユーザマスタメンテナンス
            {
              name: t('menu.user_master'),
              path: AppRoutes.userMaintance,
              component: UserMaintance,
              icon: <img src={icon_menu_display} alt="icon_menu_display" />,
              inMenu: true,
              exact: true,
              screenId: SCREEN_ID.SCREEN_USER_MAINTANCE,
            },
            {
              path: AppRoutes.userMaintanceAddAction,
              component: AddUserMaintance,
              exact: true,
              inMenu: false,
              screenId: [SCREEN_ID.SCREEN_USER_MAINTANCE_ADD],
            },
            {
              path: AppRoutes.userMaintanceDeleteAction,
              component: DeleteUserMaintance,
              exact: true,
              inMenu: false,
              screenId: [SCREEN_ID.SCREEN_USER_MAINTANCE_DELETE],
            },
            {
              path: AppRoutes.userMaintanceUpdateAction,
              component: UpdateUserMaintance,
              exact: true,
              inMenu: false,
              screenId: [SCREEN_ID.SCREEN_USER_MAINTANCE_UPDATE],
            },
            // 取引先Grマスタメンテナンス
            {
              name: t('menu.account_group_master'),
              path: AppRoutes.accountGrMaster,
              component: AccountGrMaster,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_ACCOUNT_GR_MASTER_SEARCH,
            },
            {
              path: AppRoutes.accountGrMasterSearch,
              component: AccountGrRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_ACCOUNT_GR_MASTER_ADD,
                SCREEN_ID.SCREEN_ACCOUNT_GR_MASTER_UPDATE,
                SCREEN_ID.SCREEN_ACCOUNT_GR_MASTER_DELETE,
              ],
            },
            // ステータスマスタメンテナンス
            {
              name: t('menu.status_master'),
              path: AppRoutes.statusMaster,
              component: StatusMaster,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_STATUS_MASTER_SEARCH,
            },
            {
              path: AppRoutes.statusMasterSearch,
              component: StatusRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_STATUS_MASTER_ADD,
                SCREEN_ID.SCREEN_STATUS_MASTER_UPDATE,
                SCREEN_ID.SCREEN_STATUS_MASTER_DELETE,
              ],
            },
            // メニューパターンメンテナンス
            {
              name: t('menu.menu_authority_master'),
              path: AppRoutes.menuAuthorityMaster,
              component: MenuAuthorityMaster,
              inMenu: true,
              exact: true,
              screenId: SCREEN_ID.SCREEN_MENU_AUTHORITY_MASTER_SEARCH,
            },
            {
              path: AppRoutes.menuAuthorityMasterSearch,
              component: MenuAuthorityRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_MENU_AUTHORITY_MASTER_ADD,
                SCREEN_ID.SCREEN_MENU_AUTHORITY_MASTER_UPDATE,
                SCREEN_ID.SCREEN_MENU_AUTHORITY_MASTER_DELETE,
              ],
            },
            // 項目表示マスタメンテナンス
            {
              name: t('menu.display_item_master'),
              path: AppRoutes.displayItem,
              component: DisplayItemMaintenance,
              inMenu: true,
              icon: <img src={icon_menu_display} alt="icon_menu_display" />,
              exact: true,
              screenId: SCREEN_ID.SCREEN_DISPLAY_ITEM,
            },
            {
              path: AppRoutes.displayItemSearch,
              component: RegisterPage,
              icon: <img src={icon_menu_display} alt="icon_menu_display" />,
              exact: false,
              screenId: [
                SCREEN_ID.SCREEN_DISPLAY_ITEM_DELETE,
                SCREEN_ID.SCREEN_DISPLAY_ITEM_REGISTRATION,
                SCREEN_ID.SCREEN_DISPLAY_ITEM_UPDATE,
              ],
            },
            // 港マスタメンテナンス
            {
              name: t('menu.port_master'),
              path: AppRoutes.portMaster,
              component: PortMaster,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_PORT_MASTER_SEARCH,
            },
            {
              path: AppRoutes.portMasterSearch,
              component: PortRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_PORT_MASTER_ADD,
                SCREEN_ID.SCREEN_PORT_MASTER_UPDATE,
                SCREEN_ID.SCREEN_PORT_MASTER_DELETE,
              ],
            },
            // 取引先マスタメンテナンス
            {
              name: t('menu.account_master'),
              path: AppRoutes.accountMaster,
              component: AccountMaster,
              inMenu: true,
              icon: <img src={icon_menu_display} alt="icon_menu_display" />,
              exact: true,
              screenId: SCREEN_ID.SCREEN_ACCOUNT_MASTER_SEARCH,
            },
            {
              path: AppRoutes.accountMasterSearch,
              component: AccountRegister,
              inMenu: false,
              exact: true,
              screenId: [
                SCREEN_ID.SCREEN_ACCOUNT_MASTER_ADD,
                SCREEN_ID.SCREEN_ACCOUNT_MASTER_UPDATE,
                SCREEN_ID.SCREEN_ACCOUNT_MASTER_DELETE,
              ],
            },
            // 汎用マスタメンテナンス
            {
              name: t('menu.general_master'),
              path: AppRoutes.generalMaster,
              component: GeneralMaster,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_GENERAL_MASTER_SEARCH,
            },
            {
              path: AppRoutes.generalMasterSearch,
              component: GeneralRegister,
              inMenu: false,
              exact: true,
              screenId: [SCREEN_ID.SCREEN_GENERAL_MASTER_ADD, SCREEN_ID.SCREEN_GENERAL_MASTER_UPDATE],
            },
            // 検索パターン設定
            {
              name: t('menu.search_pattern'),
              path: AppRoutes.searchPattern,
              component: SearchPattern,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_SEARCH_PATTERN_SEARCH,
            },
            {
              path: AppRoutes.searchPatternSearch,
              component: SearchPatternRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_SEARCH_PATTERN_ADD,
                SCREEN_ID.SCREEN_SEARCH_PATTERN_UPDATE,
                SCREEN_ID.SCREEN_SEARCH_PATTERN_DELETE,
              ],
            },
            // AITGrマスタメンテナンス
            {
              name: t('menu.ait_group_master'),
              path: AppRoutes.aitGrMaster,
              component: AitGrMaster,
              exact: true,
              inMenu: true,
              screenId: SCREEN_ID.SCREEN_AIT_GR_MASTER_SEARCH,
            },
            {
              path: AppRoutes.aitGrMasterSearch,
              component: AitGrRegister,
              exact: true,
              inMenu: false,
              screenId: [
                SCREEN_ID.SCREEN_AIT_GR_MASTER_ADD,
                SCREEN_ID.SCREEN_AIT_GR_MASTER_UPDATE,
                SCREEN_ID.SCREEN_AIT_GR_MASTER_DELETE,
              ],
            },
          ],
        },
      ],
    },
  ];
};
